<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        props: {
            serviceName: {
                type: String,
                default: ()=>{ return '' },
            },
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/promotions/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/promotions/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Клиенты',
                        url: `/promotions/${this.$route.params.id}/clients`
                    },
                    {
                        title: 'Импорт',
                        url: `/promotions/${this.$route.params.id}/import`
                    },
                ]
            }
        },
    }
</script>
